import { put, takeLatest, select, cancelled } from 'redux-saga/effects';
import { filter, get, isNil } from 'lodash';
import linkMap, {
  unavailableSituationsLinksByConvertationStatus as hideLinks,
} from '../../constants/situationsCodeMapping';
import { seachSituations } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const appStore = yield select((state) => state.app);
  const isConvertation = yield appStore.user.getIn(['data', 'isConvertation']);
  const acceptHardCopy = yield appStore.user.getIn(['data', 'acceptHardCopy']) ? '2' : '1';
  const { request, cancel: requestCancel } = seachSituations(action.payload);
  try {
    const response = yield request;
    if (response.isOk) {
      const filtered = filter(response.data, (situation) => {
        if (isConvertation) {
          return !hideLinks[situation.code];
        }
        const hardCopy = get(linkMap[situation.code], 'hardCopy');
        return acceptHardCopy === hardCopy || isNil(hardCopy);
      });
      return yield put(requestSuccess(filtered));
    }
    return yield put(requestFailure(response.error));
  } finally {
    if (yield cancelled()) {
      requestCancel();
    }
  }
}

export default function* regionsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
